module.exports = __webpack_public_path__ + "static/media/Print.a2e874a9.svg";